import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericPopupComponent, PopupButton } from '../generic-popup/generic-popup.component';

@Component({
    selector: 'app-delete-popup',
    imports: [CommonModule, GenericPopupComponent],
    templateUrl: './delete-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./delete-popup.component.css']
})
export class DeletePopupComponent implements OnChanges {
  @Input() message: string;
  @Input() visible: boolean;
  @Input() entryToRemove: any;
  @Input() title?: string;
  /** Confirm button text, e.g. "Yes, remove" when something is only taken off, not deleted. */
  @Input() confirmText?: string;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Output() onAbort = new EventEmitter<boolean>();
  @Output() visibleChange = new EventEmitter<boolean>();

  localVisible = signal(false);
  popupTitle = $localize`:@@delete:Delete`;

  private buttonClicked = false;

  abortButtons: PopupButton[] = [];

  confirmButtons: PopupButton[] = [
    {
      text: $localize`:@@abort:Abort`,
      type: 'tertiary-text',
      onClick: () => {
        this.buttonClicked = true;
        this.onAbort.emit(false);
        this.visibleChange.emit(false);
      },
    },
    {
      text: $localize`:@@yesDelete:Yes, delete`,
      type: 'danger',
      onClick: () => {
        this.buttonClicked = true;
        this.onConfirm.emit(true);
        this.visibleChange.emit(false);
      },
    },
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']) {
      this.localVisible.set(this.visible);
    }
    if (changes['confirmText'] && this.confirmText) {
      // last button is the confirm button
      this.confirmButtons = this.confirmButtons.map((b, i) => (i === this.confirmButtons.length - 1 ? { ...b, text: this.confirmText! } : b));
    }
  }

  onHidingHandler() {
    if (!this.buttonClicked) {
      this.onAbort.emit(false);
      this.visibleChange.emit(false);
    }
    this.buttonClicked = false;
  }
}
